import { useState } from 'react'
import { usePermissions } from '../../hooks/usePermissions'
import { PERMISSIONS } from '../../lib/permissions'
import { AccessDenied, DateRangeBar, firstOfMonth, today } from './shared'
import TimeSlotsTab from './TimeSlotsTab'

const TimeSlotsPage = () => {
  const { hasPermission } = usePermissions()
  const [startDate, setStartDate] = useState(firstOfMonth())
  const [endDate, setEndDate] = useState(today())

  // Both permissions are required: the old Reports page gated the whole screen on
  // order.financial.view and only spliced the Time Slots tab in with order.list.all.
  // The sidebar can only express OR, so the page enforces the AND.
  const canView =
    hasPermission(PERMISSIONS.ORDER_FINANCIAL_VIEW) && hasPermission(PERMISSIONS.ORDER_LIST_ALL)

  if (!canView) return <AccessDenied />

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Time Slots</h1>
        <p className="text-sm text-gray-500 mt-0.5">When the business happens — orders, revenue and kitchen speed by weekday and hour</p>
      </div>

      <DateRangeBar
        startDate={startDate}
        endDate={endDate}
        onStartChange={setStartDate}
        onEndChange={setEndDate}
      />

      <TimeSlotsTab startDate={startDate} endDate={endDate} />
    </div>
  )
}

export default TimeSlotsPage
